import { useGetMarketAccountDetailsQuery } from '@src/providers/AppStateProvider/streamingDataSlice';
import type { OTCDealData } from '@src/types/OTC';
import { EMPTY_OBJECT } from '@talos/kyoko';
import { useMemo } from 'react';

/**
 * Settlement cutoff timezone for the deal’s market account — same resolution as
 * ManualDealDateControls (used when entering dates against that counterparty context).
 */
export function useOtcDealSettlementTimezone(deal: Pick<OTCDealData, 'MarketAccount'>): string {
  const { data: marketAccountDetailsData } = useGetMarketAccountDetailsQuery(EMPTY_OBJECT);

  return useMemo(() => {
    const marketAccount = deal.MarketAccount;
    if (!marketAccount || !marketAccountDetailsData) {
      return 'UTC';
    }
    return marketAccountDetailsData.get(String(marketAccount))?.SettleCutoffTimezone ?? 'UTC';
  }, [deal.MarketAccount, marketAccountDetailsData]);
}
